// Drie standen voor hetzelfde scherm: comfortabel, compact en presenteren.
//
// Compact perst er meer taken in; presenteren doet precies het omgekeerde. Dat laatste is
// geen luxe-instelling maar de reden dat dit scherm bestaat: de dagstart gaat via een
// gedeeld scherm in Teams, en daar wordt alles een slag onscherp en kleiner. De
// 0,64rem-grijstinten die op je eigen monitor prima leesbaar zijn, verdwijnen dan
// volledig. In presentatiestand gaan de letters omhoog en de grijstinten donkerder — één
// tabel, zodat de blokken, de dagkoppen en de capaciteitsrij niet uit de pas kunnen lopen.

export const DICHTHEDEN = ['comfortabel', 'compact', 'presentatie'];

export const MATEN = {
  comfortabel: {
    blok: 34,
    taak: '0.73rem',
    detail: '0.66rem',
    icoon: 15,
    dagkop: '0.68rem',
    capaciteit: '0.66rem',
    lane: '0.64rem',
    zacht: '#64748b',
    zachter: '#94a3b8',
  },
  compact: {
    blok: 26,
    taak: '0.68rem',
    detail: '0.6rem',
    icoon: 13,
    dagkop: '0.64rem',
    capaciteit: '0.62rem',
    lane: '0.62rem',
    zacht: '#64748b',
    zachter: '#94a3b8',
  },
  presentatie: {
    blok: 46,
    taak: '0.95rem',
    detail: '0.82rem',
    icoon: 20,
    dagkop: '0.9rem',
    capaciteit: '0.92rem',
    lane: '0.8rem',
    // Donkerder dan de andere standen: een lichte grijstint overleeft geen videocompressie.
    zacht: '#334155',
    zachter: '#475569',
  },
};

export const maatVoor = (dichtheid) => MATEN[dichtheid] || MATEN.comfortabel;
